import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import brandsData from "../data/brandsData";

export default function CollectionsSection() {
    const { t } = useTranslation();
    const [selectedImage, setSelectedImage] = useState(null);
    const showData = brandsData.slice(0, 6).map((el, index) => (
        <div
            className="w-100 w-[32%] h-[250px] rounded-[4px] border border-[#b58630] cursor-pointer opacity-0 animate-fadeIn"
            style={{ animationDelay: `${index * 0.1}s` }}
            key={el.id}
            onClick={() => setSelectedImage(el.image)}
        >
            <img className="w-full h-full object-cover" src={el.image} alt="" />
        </div>
    ));

    // إغلاق الـ Pop-up
    const closePopup = () => setSelectedImage(null);


    return (
        <>
            <section className="relative py-[40px]">
                <div className="main-title">our Collections</div>
                <div className="container flex flex-col gap-[20px] justify-center items-center">
                    <div className="flex flex-wrap gap-[20px] justify-between">
                        {showData}
                    </div>
                    <Link
                        to="/collections"
                        className="inline-block bg-[#b58630] text-white py-4 px-10 rounded-full font-bold text-xl hover:bg-[#a57729] transition-transform transform hover:scale-110 shadow-lg glow"
                    >
                        {t("Show More")}
                    </Link>
                </div>
            </section>
            {/* Pop-up */}
            {selectedImage && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="w-90 relative bg-white p-4 rounded-[8px] w-[600px] h-[600px] animate-popIn">
                        <button
                            className="absolute top-2 right-2 text-[24px] font-bold bg-red-500 w-[30px] h-[30px] rounded-full flex items-center justify-center text-center text-white"
                            onClick={closePopup}
                        >
                            <img className="w-[12px] h-[12px]" src={require("../../assets/icons/x.svg").default} alt="" />
                        </button>
                        <img
                            className="w-full h-full object-contain"
                            src={selectedImage}
                            alt="Enlarged"
                        />
                    </div>
                </div>
            )}
        </>
    );
}